import React, { useEffect, useState } from "react";
import { DropLi } from "../../../../../hooks";

const ProductStatus = ({ value }) => {
  const { ReturnReason } = DropLi();
  const [returnReason, setReturnReason] = useState("");

  useEffect(() => {
    if (value && value.id) {
      var _reason = ReturnReason.find((j) => j.id === value.returnReason);
      _reason && setReturnReason(_reason.label);
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="flex flex-col gap-1">
      <div>
        {value.isSellable ? (
          <span className="text-[11px] uppercase tracking-wider bg-green-500 pl-2 pr-2 p-1 text-white rounded-[15px] shadow-md">
            Sellable
          </span>
        ) : (
          <span className="text-[11px] uppercase tracking-wider bg-red-500 pl-2 pr-2 p-1 text-white rounded-[15px] shadow-md">
            Not Sellabe
          </span>
        )}
      </div>

      <span className="text-[11px] font-medium uppercase">{returnReason}</span>
    </div>
  );
};

export default ProductStatus;
